module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dados-da-solicitacao",
    attrs: {
      "id": "detalhes-da-solicitacao"
    }
  }, [_c('div', {
    staticClass: "container container_com-fundo container_com-margem"
  }, [_c('loading', {
    attrs: {
      "ativo": _vm.loading.visivel,
      "mensagem": _vm.loading.mensagem
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', {
    staticClass: "print title-print"
  }, [_vm._v("Detalhes da solicitação")]), _vm._v(" "), _c('div', {
    staticClass: "grade__linha grade__linha_alinhar-vertical-ao-topo"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_3"
  }, [_c('div', {
    staticClass: "titulo titulo_gigante u-margem-inferior-pequena"
  }, [_vm._v("\n          Subsídio da AGEHAB\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "titulo titulo_medio u-margem-inferior-pequena"
  }, [_vm._v("\n          " + _vm._s(_vm.subsidioDaAgehab) + "\n        ")]), _vm._v(" "), _c('div', {
    class: [
      'tags',
      _vm.classeCssDaCor(
        'tags',
        _vm.obterCorDoStatusDaSolicitacao(_vm.statusDaSolicitacao)
      ) ]
  }, [_vm._v("\n          " + _vm._s(_vm.status) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_9"
  }, [_c('div', {
    staticClass: "u-nao-imprimir grade__linha grade__linha_alinhar-horizontal-direita"
  }, [(_vm.acoesPermidasDaSolicitacao.PermiteAprovacao) ? _c('button', {
    staticClass: "no-print botao botao_cor-terciaria botao_com-icone-para-esquerda botao_contorno botao_sem-preenchimento botao_medio u-margem-direita-media",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.abrirModalDeAprovacao
    }
  }, [_vm._v("\n            Aprovar\n          ")]) : _vm._e(), _vm._v(" "), (_vm.acoesPermidasDaSolicitacao.PermiteAprovacaoDeCertificado) ? _c('button', {
    staticClass: "no-print botao botao_cor-terciaria botao_com-icone-para-esquerda botao_contorno botao_sem-preenchimento botao_medio u-margem-direita-media",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.abrirModalDeAprovacaoDeCertificado
    }
  }, [_vm._v("\n            Aprovar\n          ")]) : _vm._e(), _vm._v(" "), (_vm.acoesPermidasDaSolicitacao.PermiteCancelamento) ? _c('button', {
    staticClass: "no-print botao botao_cor-terciaria botao_com-icone-para-esquerda botao_contorno botao_sem-preenchimento botao_medio u-margem-inferior-grande",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.abrirModalDeCancelamento
    }
  }, [_vm._v("\n            Indeferir\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "no-print grade__linha grade__linha_alinhar-horizontal-direita"
  }, [_c('div', {
    staticClass: "dropdown dropdown_direita"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "dropdown__lista",
    attrs: {
      "ul": "",
      "aria-label": "Submenu"
    }
  }, [_c('li', {
    staticClass: "dropdown__item"
  }, [(_vm.acoesPermidasDaSolicitacao.PermiteEdicao) ? _c('button', {
    staticClass: "no-print botao botao_cinza botao_com-icone-para-esquerda botao_sem-preenchimento botao_medio largura-maxima u-texto-alinhado-a-esquerda",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.redirecionarParaEdicao
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Editar\n                ")]) : _vm._e()]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', {
    staticClass: "dropdown__item"
  }, [(
    _vm.acoesPermidasDaSolicitacao.PermiteEntregaDoCertificado
  ) ? _c('button', {
    staticClass: "no-print botao botao_cinza botao_com-icone-para-esquerda botao_sem-preenchimento botao_medio largura-maxima u-texto-alinhado-a-esquerda",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.abrirModalDeEntregaDoCertificado()
      }
    }
  }, [_c('i', {
    staticClass: "far fa-person-carry",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                  Informar entrega\n                ")]) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "dropdown__item"
  }, [(
    _vm.acoesPermidasDaSolicitacao.PermiteDownloadDaDeclaracao
  ) ? _c('button', {
    staticClass: "no-print botao botao_cinza botao_com-icone-para-esquerda botao_sem-preenchimento botao_medio largura-maxima u-texto-alinhado-a-esquerda",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.baixarDeclaracao()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Baixar\n                  declaração\n                ")]) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "dropdown__item"
  }, [(
    _vm.acoesPermidasDaSolicitacao.PermiteDownloadDoCertificado
  ) ? _c('button', {
    staticClass: "no-print botao botao_cinza botao_com-icone-para-esquerda botao_sem-preenchimento botao_medio largura-maxima u-texto-alinhado-a-esquerda",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.baixarCertificado()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Baixar\n                  certificado\n                ")]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "borda"
  }, [_c('h2', {
    staticClass: "titulo titulo_pequeno u-margem-inferior-media title is-5"
  }, [_vm._v("\n        Dados do Proponente\n      ")]), _vm._v(" "), _vm._l((_vm.proponentes), function(proponente, index) {
    return _c('div', [_c('span', {
      staticClass: "titulo titulo_pequeno"
    }, [_vm._v("\n          " + _vm._s(index + 1) + "º Proponente\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "field is-horizontal"
    }, [_c('div', {
      staticClass: "linha"
    }, [_c('div', {
      staticClass: "field coluna"
    }, [_vm._m(3, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(proponente.Nome))])]), _vm._v(" "), _c('div', {
      staticClass: "field coluna"
    }, [_vm._m(4, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(proponente.Cpf))])]), _vm._v(" "), _c('div', {
      staticClass: "field coluna"
    }, [_vm._m(5, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(proponente.Telefone || "NÃO INFORMADO"))])])])]), _vm._v(" "), (proponente.Conjuge) ? _c('div', [_c('span', {
      staticClass: "titulo titulo_pequeno"
    }, [_vm._v("\n            " + _vm._s(index + 1) + "º Cônjuge\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "field is-horizontal"
    }, [_c('div', {
      staticClass: "linha"
    }, [_c('div', {
      staticClass: "field coluna"
    }, [_vm._m(6, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(proponente.Conjuge.Nome))])]), _vm._v(" "), _c('div', {
      staticClass: "field coluna"
    }, [_vm._m(7, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(proponente.Conjuge.Cpf))])]), _vm._v(" "), _c('div', {
      staticClass: "field coluna"
    }, [_vm._m(8, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(proponente.Conjuge.Telefone || "NÃO INFORMADO"))])])])])]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "field-body field-body-linha"
  }, [_c('div', {
    staticClass: "field"
  }, [_vm._m(9), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.rendaTotalComprovada))])])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "borda"
  }, [_c('h2', {
    staticClass: "titulo titulo_pequeno u-margem-inferior-media title is-5"
  }, [_vm._v("\n        Dados do Imóvel\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "linha"
  }, [_c('div', {
    staticClass: "field coluna"
  }, [_vm._m(10), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.construtora.Nome))])]), _vm._v(" "), _c('div', {
    staticClass: "field coluna"
  }, [_vm._m(11), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.construtora.Cnpj))])])]), _vm._v(" "), _c('div', {
    staticClass: "linha"
  }, [_c('div', {
    staticClass: "field coluna"
  }, [_vm._m(12), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.imovel.Apf))])]), _vm._v(" "), _c('div', {
    staticClass: "field coluna"
  }, [_vm._m(13), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.construtora.Conta))])])]), _vm._v(" "), _c('div', {
    staticClass: "linha"
  }, [_c('div', {
    staticClass: "field coluna"
  }, [_vm._m(14), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.cidade.Nome + " - " + _vm.cidade.EstadoNome))])]), _vm._v(" "), _c('div', {
    staticClass: "field coluna"
  }, [_vm._m(15), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.endereco.TipoDeLogradouro.Nome) + " " + _vm._s(_vm.endereco.Logradouro) + ",\n              nº " + _vm._s(_vm.endereco.NumeroDoImovel))])])]), _vm._v(" "), _c('div', {
    staticClass: "linha"
  }, [_c('div', {
    staticClass: "field coluna"
  }, [_vm._m(16), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.endereco.Cep))])]), _vm._v(" "), _c('div', {
    staticClass: "field coluna"
  }, [_vm._m(17), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.endereco.Bairro) + ", " + _vm._s(_vm.endereco.Complemento))])])]), _vm._v(" "), _c('div', {
    staticClass: "linha"
  }, [_c('div', {
    staticClass: "field coluna"
  }, [_vm._m(18), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.empreendimento.Nome))])]), _vm._v(" "), _c('div', {
    staticClass: "field coluna"
  }, [_vm._m(19), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.empreendimento.TipoDeEmpreendimento))])])]), _vm._v(" "), _c('div', {
    staticClass: "linha"
  }, [_c('div', {
    staticClass: "field coluna"
  }, [_vm._m(20), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.valorDaCompraEVenda))])]), _vm._v(" "), _c('div', {
    staticClass: "field coluna"
  }, [_vm._m(21), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.valorDoFinanciamentoAprovado))])])]), _vm._v(" "), _c('div', {
    staticClass: "linha"
  }, [_c('div', {
    staticClass: "field coluna"
  }, [_vm._m(22), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.subsidioDoGovernoFederal))])]), _vm._v(" "), _c('div', {
    staticClass: "field coluna"
  }, [_vm._m(23), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.subsidioDaAgehab))])])]), _vm._v(" "), _c('div', {
    staticClass: "linha"
  }, [_c('div', {
    staticClass: "field coluna"
  }, [_vm._m(24), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.descontoDaConstrutora))])]), _vm._v(" "), _c('div', {
    staticClass: "field coluna"
  }, [_vm._m(25), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.participacaoDoSolicitante))])])]), _vm._v(" "), _c('div', {
    staticClass: "linha"
  }, [_c('div', {
    staticClass: "field coluna"
  }, [_vm._m(26), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.imovel.Matricula))])])])])]), _vm._v(" "), _c('h2', {
    staticClass: "titulo titulo_medio u-margem-superior-media"
  }, [_vm._v("\n      Histórico da solicitação\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "historico-situacao timeline-body"
  }, _vm._l((_vm.historicoDoStatus), function(historicoItem) {
    return _c('div', {
      staticClass: "timeline-container"
    }, [_c('div', {
      staticClass: "timeline-item"
    }, [_vm._m(27, true), _vm._v(" "), _c('span', {
      staticClass: "informacoes"
    }, [(historicoItem.DescricaoDoStatus !== 'NULO') ? _c('span', {
      class: [
        'u-margem-inferior-pequena tags',
        _vm.classeCssDaCor(
          'tags',
          _vm.obterCorDoStatusDaSolicitacao(historicoItem.Status)
        ) ]
    }, [_vm._v("\n              " + _vm._s(historicoItem.DescricaoDoStatus) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "data-situacao u-margem-inferior-mini"
    }, [_c('strong', [_vm._v("Data:")]), _vm._v("\n              " + _vm._s(historicoItem.DataDoEvento) + "\n            ")]), _vm._v(" "), (historicoItem.Usuario.Nome) ? _c('span', {
      staticClass: "data-situacao u-margem-inferior-mini"
    }, [_c('strong', [_vm._v("Responsável:")]), _vm._v("\n              " + _vm._s(historicoItem.Usuario.Nome) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.permiteExibirJustificativaNoHistorico(historicoItem)) ? _c('span', {
      staticClass: "data-situacao u-margem-inferior-mini"
    }, [_c('strong', [_vm._v("Justificativa:")]), _vm._v("\n              " + _vm._s(historicoItem.Observacao) + "\n            ")]) : _vm._e()])])])
  }), 0), _vm._v(" "), (_vm.modalDeAprovacaoEstaVisivel) ? _c('modal', {
    on: {
      "close": _vm.fecharModalDeAprovacao
    }
  }, [_c('form', {
    staticClass: "formulario",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.aprovar.apply(null, arguments)
      }
    }
  }, [_c('h3', {
    staticClass: "titulo titulo_medio u-margem-inferior-media"
  }, [_vm._v("\n          Aprovar solicitação\n        ")]), _vm._v(" "), _c('hr', {
    staticClass: "u-margem-inferior-grande"
  }), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "mensagem-confirmacao u-margem-inferior-grande"
  }, [_c('strong', [_vm._v("Tem certeza que deseja aprovar essa solicitação?")])])]), _vm._v(" "), _c('div', {
    staticClass: "grade__linha_alinhar-horizontal-direita formulario-button"
  }, [_c('button', {
    staticClass: "botao botao_cinza botao_medio u-margem-direita-pequena",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fecharModalDeAprovacao
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "botao botao_cor-terciaria botao_medio",
    class: {
      'is-loading': _vm.loading.visivel
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n            Confirmar\n          ")])])])]) : _vm._e(), _vm._v(" "), (_vm.modalDeEntregaDoCertificadoEstaVisivel) ? _c('modal', {
    on: {
      "close": _vm.fecharModalDeEntregaDoCertificado
    }
  }, [_c('form', {
    staticClass: "formulario",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.entregarCertificado.apply(null, arguments)
      }
    }
  }, [_c('h3', {
    staticClass: "titulo titulo_medio u-margem-inferior-media"
  }, [_vm._v("\n          Informar data de entrega do certificado\n        ")]), _vm._v(" "), _c('hr', {
    staticClass: "u-margem-inferior-grande"
  }), _vm._v(" "), _c('div', {
    staticClass: "u-margem-inferior-grande"
  }, [_c('div', {
    staticClass: "grade__coluna_5"
  }, [_c('p', [_vm._v("\n              Nome: " + _vm._s(_vm.proponentes[0].Nome) + " "), _c('br'), _vm._v("\n              CPF: " + _vm._s(_vm.proponentes[0].Cpf) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna_5 u-margem-superior-media"
  }, [_c('label', {
    staticClass: "label u-margem-bottom-mini",
    attrs: {
      "for": "dataDeEntregaDoCertificado"
    }
  }, [_vm._v("Data da entrega")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataDeEntregaDoCertificado),
      expression: "dataDeEntregaDoCertificado"
    }],
    staticClass: "formulario__input u-margem-superior-pequena",
    attrs: {
      "id": "dataDeEntregaDoCertificado-",
      "name": "dataDeEntregaDoCertificado",
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": (_vm.dataDeEntregaDoCertificado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataDeEntregaDoCertificado = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "u-margem-superior-grande grade__linha_alinhar-horizontal-direita formulario-button"
  }, [_c('button', {
    staticClass: "botao botao_cinza botao_medio u-margem-direita-pequena",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fecharModalDeEntregaDoCertificado
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "botao botao_cor-terciaria botao_medio",
    class: {
      'is-loading': _vm.loading.visivel
    },
    attrs: {
      "type": "submit",
      "disabled": !_vm.dataDeEntregaDoCertificado
    }
  }, [_vm._v("\n            Salvar\n          ")])])])]) : _vm._e(), _vm._v(" "), (_vm.modalDeAprovacaoDeCertificadoEstaVisivel) ? _c('modal', {
    on: {
      "close": _vm.fecharModalDeAprovacaoDeCertificado
    }
  }, [_c('form', {
    staticClass: "formulario",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.aprovarCertificado.apply(null, arguments)
      }
    }
  }, [_c('h3', {
    staticClass: "titulo titulo_medio u-margem-inferior-media"
  }, [_vm._v("\n          Aprovar certificado\n        ")]), _vm._v(" "), _c('hr', {
    staticClass: "u-margem-inferior-grande"
  }), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "mensagem-confirmacao u-margem-inferior-grande"
  }, [_c('strong', [_vm._v("Tem certeza que deseja aprovar o certificado?")])])]), _vm._v(" "), _c('div', {
    staticClass: "grade__linha_alinhar-horizontal-direita formulario-button"
  }, [_c('button', {
    staticClass: "botao botao_cinza botao_medio u-margem-direita-pequena",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fecharModalDeAprovacaoDeCertificado
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "botao botao_cor-terciaria botao_medio",
    class: {
      'is-loading': _vm.loading.visivel
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n            Confirmar\n          ")])])])]) : _vm._e(), _vm._v(" "), (_vm.modalDeCancelamentoEstaVisivel) ? _c('modal', {
    on: {
      "close": _vm.fecharModalDeCancelamento
    }
  }, [_c('form', {
    staticClass: "formulario",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.cancelar.apply(null, arguments)
      }
    }
  }, [_c('h3', {
    staticClass: "titulo titulo_medio u-margem-inferior-media"
  }, [_vm._v("\n          Cancelar solicitação\n        ")]), _vm._v(" "), _c('hr', {
    staticClass: "u-margem-inferior-media"
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "justificativa"
    }
  }, [_vm._v("Motivo do cancelamento")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.justificativa),
      expression: "justificativa"
    }],
    staticClass: "input u-margem-inferior-media",
    attrs: {
      "name": "justificativa",
      "id": "justificativa",
      "cols": "30",
      "rows": "8",
      "placeholder": "Descreva o motivo do cancelamento",
      "required": ""
    },
    domProps: {
      "value": (_vm.justificativa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.justificativa = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grade__linha_alinhar-horizontal-direita formulario-button"
  }, [_c('button', {
    staticClass: "botao botao_cinza botao_medio u-margem-direita-pequena",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fecharModalDeCancelamento
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "botao botao_cor-terciaria botao_medio",
    class: {
      'is-loading': _vm.loading.visivel
    },
    attrs: {
      "type": "submit",
      "disabled": !_vm.justificativa
    }
  }, [_vm._v("\n            Confirmar\n          ")])])])]) : _vm._e(), _vm._v(" "), _c('MensagemFlutuante', {
    attrs: {
      "mensagemVisivel": _vm.mensagemVisivel,
      "titulo": _vm.tituloMensagem,
      "estilo": _vm.estiloMensagem,
      "texto": _vm.textoMensagem
    },
    on: {
      "close": _vm.fecharMensagem
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logos print has-text-centered"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/imagens/logo-relatorio-retrato.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "botao botao_cinza botao_com-icone-para-direita botao_sem-preenchimento botao_medio",
    attrs: {
      "aria-haspopup": "true"
    }
  }, [_vm._v("\n              Ações "), _c('i', {
    staticClass: "far fa-chevron-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown__item"
  }, [_c('button', {
    staticClass: "no-print botao botao_cinza botao_com-icone-para-esquerda botao_sem-preenchimento botao_medio largura-maxima u-texto-alinhado-a-esquerda",
    attrs: {
      "type": "button",
      "onclick": "window.print()"
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Imprimir\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Nome:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("CPF:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Telefone: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Nome:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("CPF:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Telefone: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Renda familiar comprovada:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Construtora:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("CNPJ:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("APF:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Conta vinculada:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Cidade:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Endereço:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("CEP:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Bairro/Complemento:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Empreendimento:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Tipo de empreendimento:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Valor de compra e venda:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Valor do financiamento:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Subsídio do Governo Federal:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Subsídio da AGEHAB:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Desconto da construtora:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Participação do proponente:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Matrícula:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "marcacao"
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-506eada4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-506eada4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/controle-de-solicitacoes/mcmv-cidades/DetalhesDaSolicitacaoParaMcmvCidades.vue
// module id = 1115
// module chunks = 1